import { useMemo, useState } from 'react';
import { cleanEmptyFilters, filterToExpression } from '@utils/filterUtils';
import { useAvContext } from '../context/AvContextProvider';
import { Filter } from '../types/filter.types';

export const extractMeasurementDescription = (option: unknown, measurements: Record<string, { description?: string }>) => {
  const value = option && typeof option === 'object' && 'value' in option && typeof option.value === 'string' ? option.value : undefined;
  return value ? measurements?.[value]?.description : undefined;
};

export const useSelectivityFilter = (defaultFilter: Record<string, string[]>) => {
  const {
    accountEntities: { fieldTypeMap },
  } = useAvContext();
  const [selectivityFilter, setSelectivityFilter] = useState<Filter | undefined>(
    cleanEmptyFilters(filterToExpression(fieldTypeMap, defaultFilter))
  );
  const onApplyFilter = (currentFilters = filters) =>
    setSelectivityFilter(cleanEmptyFilters(filterToExpression(fieldTypeMap, currentFilters)));
  const [filters, setFilters] = useState<Record<string, string[]>>(defaultFilter);
  const hasNewFilters = useMemo(
    () => JSON.stringify(selectivityFilter) !== JSON.stringify(cleanEmptyFilters(filterToExpression(fieldTypeMap, filters))),
    [filters, selectivityFilter, fieldTypeMap]
  );
  return {
    filters,
    setFilters,
    onApplyFilter,
    hasNewFilters,
    selectivityFilter,
    setSelectivityFilter,
  };
};
